import { APP_BASE_HREF } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { apiUrl, CUSTOM_ASSETS_URL } from '@app/app.constants';
import { AppInfo } from '@app/portal/models/app-info';
import { Branding } from '@app/portal/models/branding';
import { PortalVersion } from '@app/portal/models/portal-version';
import { Preferences } from '@app/portal/models/preferences';
import { TranslationMeta } from '@app/translate/models/translation-meta';
import { wrapError } from '@app/utils/rxjs';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PortalRepository {
  constructor(
    private http: HttpClient,
    @Inject(APP_BASE_HREF) private baseHref: string
  ) {}

  versionParam = { v: environment.version };

  appInfo(enterpriseName?: string): Observable<AppInfo> {
    let ps: HttpParams = new HttpParams();
    ps = ps.set('v', this.versionParam.v);
    if (enterpriseName != null) {
      ps = ps.set('enterpriseName', enterpriseName);
    }
    return this.http
      .get<AppInfo>(apiUrl('/info'), { params: ps })
      .pipe(wrapError('portal-repository:app-info'));
  }

  branding(): Observable<Branding> {
    return this.http
      .get<Branding>(apiUrl('/branding'), { params: this.versionParam })
      .pipe(wrapError('portal-repository:branding'));
  }

  preferences(): Observable<Preferences> {
    return this.http
      .get<Preferences>(apiUrl('/me/portalPreferences'), { params: this.versionParam })
      .pipe(wrapError('portal-repository:preferences'));
  }

  translationMeta(): Observable<TranslationMeta> {
    return this.http
      .get<TranslationMeta>(`${CUSTOM_ASSETS_URL}/assets/i18n/translations.json`)
      .pipe(wrapError('portal-repository:translation-meta'));
  }

  updatePreferences(preferences: Preferences): Observable<Preferences> {
    return this.http
      .put<Preferences>(apiUrl('/me/portalPreferences'), preferences)
      .pipe(wrapError('portal-repository:update-preferences'));
  }

  version() {
    return this.http
      .get<PortalVersion>(this.baseHref + 'assets/version.json', { params: this.versionParam })
      .pipe(wrapError('portal-repository:version'));
  }
}
